export const tags = [
    'CorrectedImage',
    'Units',
    'DecayCorrection',
];
